module.exports = __webpack_public_path__ + "img/9b6b6053f6624ca8bde4cfe30e29962c.cc6b4e45.png";